// Rounding function
export function ROUND(value: number, decimals = 0): number {
  const factorOfTen = Math.pow(10, decimals);
  return Math.round(value * factorOfTen) / factorOfTen;
}

export function formatNumberWithAbbreviations(num: number) {
  if (num >= 1e9) {
    return (num / 1e9).toFixed(1) + 'B';
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1) + 'M';
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(1) + 'K';
  }
}

export function formatNumberWithAbbreviationsLetters(num: number) {
  if (num >= 1e9) {
    return 'B';
  } else if (num >= 1e6) {
    return 'M';
  } else if (num >= 1e3) {
    return 'K';
  }
}

export function ROUNDUP(number: number, digits = 0) {
  const factor = Math.pow(10, digits);
  return Math.ceil(number * factor) / factor;
}
